ACC.billpay = {

  bindAll: function() {
    $('.change_billing_address_billingbutton').on('click', ACC.billpay.handleChangBillingeAddressButtonClick);
    $('.change_billing_address_payeebutton').on('click', ACC.billpay.handleChangePayeeAddressButtonClick);
    ACC.billpay.bindCreateUpdateAddressForm();
    $.extend({
      postJSON: function(url, data, callback) {
        return $.post(url, data, callback, 'json');
      }
    });
    $('#checkout_summary_accountpayment_div').on('click', function() {
      $('.ph-spinnerorder').removeClass('hidden');
      $('#placeOrderForm1').submit();
      $(this).addClass('ph-disabledbutton');
    });
    ACC.billpay.handlePrefilAddressList();
  },

  handleChangBillingeAddressButtonClick: function() {
    $.getJSON(document.querySelector('.ph-getBillingddressesUrl').textContent, ACC.billpay.handleBillingAddressDataLoadBill);
  },

  handleChangePayeeAddressButtonClick: function() {
    $.getJSON(document.querySelector('.ph-getPayeeAddressesUrl').textContent, ACC.billpay.handleBillingAddressDataLoadPay);
  },

  successcolorbox: function(addobj) {
    var popupHeight = '80%';

    if ($(window).width() < 768) {
      popupHeight = '100%';
      $('html').addClass('ph-modal-open');
    }

    $.colorbox({
      inline: true,
      href: addobj,
      maxWidth: '750px',
      width: '100%',
      height: popupHeight,
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onOpen: function() {
        ACC.billpay.emptyAddressForm();
        $(document).on('change', '#saveAddress', function() {
          var saveAddressChecked = $(this).prop('checked');

          $('#defaultAddress').prop('disabled', !saveAddressChecked);

          if (!saveAddressChecked) {
            $('#defaultAddress').prop('checked', false);
          }
        });
      },
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        ACC.search.searchAddress();
        $('#cboxWrapper #myInput').each(function() {
          var inputVal = $(this).val();

          $(this).focus();
          $(this).keypress(function() {
            if (this.value === inputVal) {
              this.value = '';
            }
          });
        });

        if ($('#cboxWrapper .existing_address').length > 3) {
          $('.ph-myprofileaddress__searchparent').show();
        } else {
          $('.ph-myprofileaddress__searchparent').hide();
        }
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-modal-open');
        $('#cboxWrapper #myInput').each(function() {
          $(this).focus();
        });
      }
    });
  },

  handleBillingAddressDataLoadBill: function(data) {
    var addressList = data;

    if (data.billingAddresses) {
      addressList = data.billingAddresses;
    }

    $('.delivery_addresses_list').html($('#billingAddressesTemplate').tmpl({
      addresses: addressList
    }));
    $.ajax({
      url: document.querySelector('.ph-getBillingddressesUrl').textContent,
      type: 'GET',
      dataType: 'json',
      success: function() {
        ACC.billpay.successcolorbox($('#popup_checkout_delivery_address').html());
      }
    });

    return false;
  },

  handleBillingAddressDataLoadPay: function(data) {
    $('.delivery_addresses_list1').html($('#payeeAddressesTemplate').tmpl({
      addresses: data
    }));

    $.ajax({
      url: document.querySelector('.ph-getPayeeAddressesUrl').textContent,
      type: 'GET',
      dataType: 'json',
      success: function() {
        ACC.billpay.successcolorbox($('#popup_checkout_payee_address').html());
      }
    });

    return false;
  },

  emptyAddressForm: function() {
    var options = {
      url: document.querySelector('.ph-getDeliveryAddressFormUrl').textContent,
      data: {
        addressId: '',
        createUpdateStatus: ''
      },
      type: 'GET',
      success: function(data) {
        $('#create_update_address_form_container_div').html(data);
        ACC.billpay.bindCreateUpdateAddressForm();
      }
    };

    $.ajax(options);
  },

  refreshBillingAddressSection: function(data) {
    $('#checkout_summary_billing_div').replaceWith($('#billingAddressSummaryTemplate').tmpl({
      billingAddresses: data
    }));

    $('.change_billing_address_billingbutton').on('click', ACC.billpay.handleChangBillingeAddressButtonClick);
  },

  refreshPayeeAddressSection: function(data) {
    $('#checkout_summary_payee_div').replaceWith($('#payeeAddressSummaryTemplate').tmpl({
      paymentAddress: data
    }));

    $('.change_billing_address_payeebutton').on('click', ACC.billpay.handleChangePayeeAddressButtonClick);
  },

  handleSelectExitingAddressSuccess: function(data) {
    if (data !== null) {
      ACC.billpay.refreshBillingAddressSection(data);
      ACC.placeorder.updatePlaceOrderButton();
      parent.$.colorbox.close();
    }
  },

  handleSelectPayeeAddressSuccess: function(data) {
    if (data !== null) {
      ACC.billpay.refreshPayeeAddressSection(data);
      ACC.placeorder.updatePlaceOrderButton();
      parent.$.colorbox.close();
    }
  },

  handlePrefilAddressList: function() {
    var billadd = '',
        payadd = '',
        paymentTypeAccountCode = $('.ph-paymenttypeaccountcode').val();

    if (paymentTypeAccountCode === 'ACCOUNT') {
      if ($('#prefilBillingAddress').val() === 'true') {
        var addressId = $('.ph-billingaddressid').attr('data-address-id');

        $.postJSON(document.querySelector('.ph-setBillingAddressUrl').textContent, {
          addressId: addressId
        }, ACC.billpay.handleSelectExitingAddressSuccess);
      }

      if ($('#prefilPayerAddress').val() === 'true') {
        var payerAddressId = $('.ph-payeeaddressid').attr('data-payeeaddress-id');

        $.postJSON(document.querySelector('.ph-setPayeeAddressUrl').textContent, {
          payerAddressId: payerAddressId
        }, ACC.billpay.handleSelectPayeeAddressSuccess);
      }
    }

    $(document).on('click', '#cboxContent .use_billing_address', function() {
      billadd = $(this).attr('data-address-id');
      $.colorbox.toggleLoadingOverlay();
      $.postJSON(document.querySelector('.ph-setBillingAddressUrl').textContent, {
        addressId: billadd
      }, ACC.billpay.handleSelectExitingAddressSuccess);

      return false;
    });

    $(document).on('click', '#cboxContent .use_payee_address', function() {
      payadd = $(this).attr('data-address-id');
      $.colorbox.toggleLoadingOverlay();
      $.postJSON(document.querySelector('.ph-setPayeeAddressUrl').textContent, {
        payerAddressId: payadd
      }, ACC.billpay.handleSelectPayeeAddressSuccess);

      return false;
    });
  },

  bindCreateUpdateAddressForm: function() {
    $('.create_update_address_form').each(function() {
      var options = {
        type: 'POST',
        beforeSubmit: function() {
          $('#checkout_delivery_address').block({
            message: '<img src=\'' + $('.ph-spinnerUrl').text() + '\' />'
          });
          $.colorbox.toggleLoadingOverlay();
        },
        success: function(data) {
          $('#create_update_address_form_container_div').html(data);

          var status = $('.create_update_address_id').attr('status');

          if (status !== null && status.toLowerCase() === 'success') {
            ACC.refresh.getCheckoutCartDataAndRefreshPage();
            parent.$.colorbox.close();
          } else {
            ACC.billpay.bindCreateUpdateAddressForm();
          }
        },
        complete: function() {
          $('#checkout_delivery_address').unblock();
          $.colorbox.toggleLoadingOverlay();
        }
      };

      $(this).ajaxForm(options);
    });
  }
};

$(document).ready(function() {
  ACC.billpay.bindAll();
});
